import React from 'react';
import { Coins } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function AureusPensionPage() {
  const module = getModule('aureus-pension')!;
  return (
    <ModulePageLayout module={module} Icon={Coins}>
      <Section title="The Gold Standard Behind Everything">
        <p className="text-gray-700 leading-relaxed">
          The AUS (Aureus) token is the fundamental unit of value across Bankably — each token represents a
          claim on physical gold reserves, denominated in grams. Every tokenized asset on the platform carries
          a gold collateral ratio: the percentage of its value actually backed by those reserves, which
          determines its risk classification and eligible leverage.
        </p>
      </Section>

      <Section title="Verifiable, Not Just Promised">
        <FeatureGrid
          items={[
            { title: 'Reserve Auditing', body: 'Gold reserves are maintained and verifiable through on-chain records and third-party verification.' },
            { title: 'Estimated Value in AUS', body: 'Any asset on the platform can be expressed in gold-grams-equivalent — a stable unit of account independent of fiat swings.' },
            { title: 'Aureus Score', body: 'A long-term metric measuring contribution consistency and projected retirement readiness.' },
            { title: 'Gold-Backed Pension', body: 'Regular contributions build a retirement fund tracked against the AUS conversion rate at the time of each contribution.' },
          ]}
        />
      </Section>

      <Section title="Saving for Retirement, in Gold">
        <p className="text-gray-700 leading-relaxed">
          The Pension system lets you contribute regularly toward a long-term, gold-backed retirement fund.
          Each contribution records its amount, frequency, and the AUS conversion rate at that moment, building
          a cumulative balance that moves with — rather than against — the value of gold over time.
        </p>
      </Section>
    </ModulePageLayout>
  );
}
